import { useEffect, useState } from 'react';
import { api, MeResponse } from './api';
import { Login } from './Login';
import { AdminDashboard } from './AdminDashboard';

type State = { kind: 'loading' } | { kind: 'anonymous' } | { kind: 'admin' };

export function App() {
  const [state, setState] = useState<State>({ kind: 'loading' });

  useEffect(() => {
    api.get<MeResponse>('/api/me')
      .then((me) => setState(me.kind === 'admin' ? { kind: 'admin' } : { kind: 'anonymous' }))
      .catch(() => setState({ kind: 'anonymous' }));
  }, []);

  if (state.kind === 'loading') {
    return <div className="center"><div className="muted">loading…</div></div>;
  }
  if (state.kind === 'anonymous') {
    return <Login onAuthed={() => setState({ kind: 'admin' })} />;
  }
  return <AdminDashboard onLogout={() => setState({ kind: 'anonymous' })} />;
}
